/* Yake Mall — mağaza takip / favori (2 Eki 2026)
   - Takip listesi bu tarayıcıda localStorage'da tutulur (anahtar: yk_takip_magazalar).
   - [data-yk-takip] butonları açar/kapatır; [data-yk-takip-liste] takip edilen mağazaları listeler.
   Aynı sayfada birden çok kez yüklenebilir → tek sefer çalışır. */
(function () {
  if (window.__ykTakip) return;
  window.__ykTakip = true;

  var KEY = 'yk_takip_magazalar';

  function oku() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function yaz(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* özel pencere vb. */ }
  }
  function takipte(id) {
    return oku().some(function (m) { return m.id === id; });
  }

  function butonlariGuncelle() {
    document.querySelectorAll('[data-yk-takip]').forEach(function (b) {
      var on = takipte(b.getAttribute('data-id'));
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var l = b.querySelector('[data-yk-takip-label]');
      var metin = b.getAttribute(on ? 'data-on' : 'data-off');
      if (l && metin && l.textContent !== metin) l.textContent = metin;
    });
    document.querySelectorAll('[data-yk-takip-sayi]').forEach(function (el) {
      var n = String(oku().length);
      if (el.textContent !== n) el.textContent = n;
      el.hidden = n === '0';
    });
  }

  function degistir(b) {
    var id = b.getAttribute('data-id');
    var list = oku();
    var i = list.findIndex(function (m) { return m.id === id; });
    if (i > -1) list.splice(i, 1);
    else list.unshift({
      id: id,
      name: b.getAttribute('data-name') || '',
      url: b.getAttribute('data-url') || '',
      logo: b.getAttribute('data-logo') || '',
      t: Date.now()
    });
    yaz(list);
    butonlariGuncelle();
    listeleriCiz();
    document.dispatchEvent(new CustomEvent('yk-takip:change', { detail: { list: list } }));
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-yk-takip]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    degistir(b);
  }, true);

  /* Başka sekmede değişirse */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) { butonlariGuncelle(); listeleriCiz(); }
  });

  /* ------------------------------------------------------------ */
  /* "Takip ettiğim mağazalar" listesi                             */
  /* ------------------------------------------------------------ */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function koleksiyonYolu(url) {
    try {
      var p = new URL(url, location.origin).pathname;
      var m = p.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([^\/?#]+)$/i);
      return m && m[2] !== 'vendors' ? p : null;
    } catch (e) { return null; }
  }

  function urunleriGetir(kart, url, adet) {
    var yol = koleksiyonYolu(url);
    var hedef = kart.querySelector('[data-yk-takip-urunler]');
    if (!yol || !hedef || adet < 1) { if (hedef) hedef.remove(); return; }
    fetch(yol + '/products.json?limit=' + adet, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var ps = (d.products || []).filter(function (p) { return p.images && p.images.length; }).slice(0, adet);
        if (!ps.length) { hedef.remove(); return; }
        var kok = yol.replace(/\/collections\/.*$/, '');
        hedef.innerHTML = ps.map(function (p) {
          var src = p.images[0].src;
          return '<a class="yk-takip-urun" href="' + esc(kok + '/products/' + p.handle) + '">' +
            '<img src="' + esc(src) + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="' + esc(p.title) + '" loading="lazy" width="300" height="400">' +
            '<span>' + esc(p.title) + '</span></a>';
        }).join('');
      })
      .catch(function () { hedef.remove(); });
  }

  function listeleriCiz() {
    document.querySelectorAll('[data-yk-takip-liste]').forEach(function (kap) {
      var list = oku();
      var bos = kap.parentNode.querySelector('[data-yk-takip-bos]');
      if (bos) bos.hidden = list.length > 0;
      var adet = parseInt(kap.getAttribute('data-urun-adet') || '4', 10);
      var git = kap.getAttribute('data-t-git') || 'Mağazaya git';
      var birak = kap.getAttribute('data-t-birak') || 'Takibi bırak';
      var on = kap.getAttribute('data-t-on') || '';
      kap.innerHTML = list.map(function (m) {
        var logo = m.logo
          ? '<img class="yk-takip-kart__logo" src="' + esc(m.logo) + '" alt="" loading="lazy" width="64" height="64">'
          : '<span class="yk-takip-kart__harf" aria-hidden="true">' + esc((m.name || '?').charAt(0)) + '</span>';
        return '<article class="yk-takip-kart">' +
          '<header class="yk-takip-kart__ust">' + logo +
            '<div class="yk-takip-kart__ad"><a href="' + esc(m.url) + '">' + esc(m.name) + '</a></div>' +
            '<button type="button" class="yk-takip-btn yk-takip-btn--sm is-on" data-yk-takip data-id="' + esc(m.id) + '" data-name="' + esc(m.name) + '" data-url="' + esc(m.url) + '" data-logo="' + esc(m.logo) + '" data-on="' + esc(on) + '" data-off="' + esc(kap.getAttribute('data-t-off') || '') + '" aria-pressed="true" title="' + esc(birak) + '">' +
              '<svg class="yk-takip-btn__icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.3 4.5 6.8 4.5c2 0 3.6 1.1 4.4 2.7.8-1.6 2.4-2.7 4.4-2.7 3.5 0 5.4 3.5 4.1 6.8-1.8 4.6-9.3 9.2-9.3 9.2Z"/></svg>' +
              '<span data-yk-takip-label>' + esc(on) + '</span></button>' +
          '</header>' +
          '<div class="yk-takip-kart__urunler" data-yk-takip-urunler></div>' +
          '<a class="yk-takip-kart__git" href="' + esc(m.url) + '">' + esc(git) + ' →</a>' +
        '</article>';
      }).join('');
      kap.querySelectorAll('.yk-takip-kart').forEach(function (kart, i) {
        urunleriGetir(kart, list[i].url, adet);
      });
    });
  }

  function basla() { butonlariGuncelle(); listeleriCiz(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();

  /* Sonradan gelen bölümler (editör, sepet çekmecesi vb.) */
  var zaman = null;
  new MutationObserver(function () { clearTimeout(zaman); zaman = setTimeout(butonlariGuncelle, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
